<ul class="navbar-nav ml-auto text-secondary">
  <li *ngIf="isQuicksBookSupport.showIcon">
    <div
      class="nav-item__button-container"
      [ngClass]="{ 'nav-item__button-container--modified': isSyncInProcess }"
    >
      <a href="https://support.inventoryoptimizer.ai/hc/en-us/sections/115001573087-QuickBooks-Desktop" target="_blank"
        (click)="onClickQBSupport()"
        style="text-decoration: none"
        rel="noopener"
      >
        <div
          class="nav-item__button"
          [ngClass]="{ 'nav-item__button--modified': isSyncInProcess }"
          (mouseenter)="isQuicksBookSupport.showDialog = false"
        >
          <i
            class="nav-item__button-icon icon feather icon-alert-triangle feather--modified"
          ></i>
          <span
            *ngIf="isQuicksBookSupport.showMinorIcon"
            class="nav-item__qb_minor_icon position-absolute top-0 translate-middle order border-light rounded-circle"
          >
          </span>

          <div
            class="nav-item__qb_dialog"
            [class.nav-item__qb_dialog--hidden]="
              !isQuicksBookSupport.showDialog
            "
            [class.nav-item__qb_dialog--animate]="
              isQuicksBookSupport.showDialog
            "
          >
            Do you experience syncing issues?<br />
            Have you updated QuickBooks to the most recent version?<br />
            Please click here for additional details!
          </div>

          <div class="nav-item__qb_info">
            <p class="nav-item__qb_detail">QuickBooks&nbsp;Support</p>
          </div>
        </div>
      </a>
    </div>
  </li>

  <li *ngIf="isSyncVisible">
    <app-nav-sync></app-nav-sync>
  </li>

  <li *ngIf="isForecastVisible">
    <app-nav-forecast></app-nav-forecast>
  </li>
  <li>
    <div class="dropdown drp-user" ngbDropdown placement="auto">
      <a
        href="javascript:"
        ngbDropdownToggle
        data-toggle="dropdown"
        class="report-icon text-decoration-none list-report-icon pr-0"
      >
        <svg class="mb-1" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 21V14"></path><path d="M4 10V3"></path><path d="M12 21V12"></path><path d="M12 8V3"></path><path d="M20 21v-5"></path><path d="M20 12V3"></path><path d="M1 14h6M9 8h6M17 16h6"></path></svg>
      </a>
      <div
        class="dropdown-menu dropdown-menu-right profile-notification"
        ngbDropdownMenu
      >
        <ul class="pro-body py-2">
          <li *ngIf="!isSyncInProcess && company?.lastForecastDate && !isSubscriptionExpired">
            <button
              class="custom-dropdown-item w-100 cursor-pointer"
              [ngClass]="{ 'nav-right__report--modified': isSyncInProcess }"
              (click)="forecastReport()"
            >
              <span
                class="icon-book-wrapper"
                *ngIf="!isExporting"
                [ngClass]="{ 'nav-right__report-icon--modified': isSyncInProcess }"
              >
                <i class="icon feather icon-book mr-2"></i>Forecast Report
              </span>

              <span
                *ngIf="isExporting"
                title="Please wait while the application is exporting"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              >
              </span>

              <span class="nav-right__report-content"> Forecast&nbsp;Report </span>
            </button>
          </li>

          <li *ngIf="isCalculateLostSaleVisible">
            <app-nav-lost-sale></app-nav-lost-sale>
          </li>

          <li *ngIf="tourGuideUrl">
            <button
              class="custom-dropdown-item w-100 cursor-pointer app-overview-wrapper"
              (click)="modal.show()"
            >
              <app-icon class="mr-2" name="info-book" [size]="18" aria-label="App Overview"></app-icon>App Overview
            </button>
          </li>
        </ul>
      </div>
    </div>
  </li>

  <li>
    <button
      type="button"
      class="nav-right__theme-toggle"
      [title]="themeToggleTitle"
      [attr.aria-label]="themeToggleTitle"
      (click)="toggleTheme()"
      >
        <i
          class="icon feather"
          [ngClass]="currentTheme === 'dark' ? 'icon-sun' : 'icon-moon'"
        ></i>
      </button>
  </li>

  <li class="d-none d-lg-inline-block">
    <div
      (click)="toggleFullScreen()"
      class="nav-right__full-screen js-fullscreen cursor-pointer"
    >
      <div class="position-relative">
        <span
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          title="Full Screen"
        >
          <i class="icon feather icon-maximize"></i>
        </span>
      </div>
    </div>
  </li>

  <li *ngIf="isShowIconNotification" class="pr-0">
    <div class="dropdown drp-user" ngbDropdown placement="auto">
      <a
        href="javascript:"
        ngbDropdownToggle
        data-toggle="dropdown"
        class="user-icon text-decoration-none"
        [dataTestID]="'notifications-icon-btn'"
      >
        <div class="position-relative">
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title="Notifications"
          >
            <i class="far fa-bell"></i>
            <span
              class="position-absolute top-0 translate-middle border border-light rounded-circle"
              [class.nav-item__badge]="getObjectKeys(notifications)?.length"
            >
            </span>
          </span>
        </div>
      </a>
      <div
        class="dropdown-menu dropdown-menu-right profile-notification"
        ngbDropdownMenu
      >
        <div class="pro-head bg-white border-bottom text-dark">
          <strong
            (click)="navigateToNotification()"
            class="fw-bold cursor-pointer"
          >
            Notifications
          </strong>
        </div>
        <ul *ngIf="!isLoading" class="pro-body py-2">
          <li *ngFor="let notification of getObjectKeys(notifications)">
            <a
              href="javascript://"
              class="dropdown-item"
              (click)="onClickNotification(notification)"
            >
              <span class="d-flex">
                <span
                  class="d-flex bg-red align-items-center justify-content-cent text-white rounded-circle"
                  style="width: 18px; height: 18px"
                  [class]="getBackgroundIcon(notification)"
                >
                  <span class="f-11 m-auto">
                    {{ notifications[notification]?.length }}
                  </span>
                </span>
                <span class="ml-2 text-secondary">
                  {{
                    getNotificationName(
                      notification,
                      notifications[notification]?.length
                    )
                  }}
                </span>
              </span>
            </a>
          </li>
        </ul>
        <div
          class="d-flex mb-3 justify-content-center text-secondary opacity-50"
          *ngIf="!getObjectKeys(notifications)?.length && !isLoading"
        >
          No notifications to display
        </div>
      </div>
    </div>
  </li>

  <li class="pr-0">
    <div class="dropdown drp-user" ngbDropdown placement="auto">
      <a
        href="javascript:"
        ngbDropdownToggle
        data-toggle="dropdown"
        class="user-icon text-decoration-none"
        [dataTestID]="'profile-icon-btn'"
      >
        <i
          [title]="user?.displayName || '?'"
          class="icon feather icon-user"
        ></i>
      </a>
      <div
        class="dropdown-menu dropdown-menu-right profile-notification"
        ngbDropdownMenu
      >
        <div class="pro-head bg-white text-dark border-bottom">
          <strong class="fw-bold" [dataTestID]="'user-name'">{{
            user?.displayName || "?"
          }}</strong>
        </div>
        <ul class="pro-body py-2">
          <li>
            <a
              href="javascript://"
              class="dropdown-item"
              (click)="navigateToProfile()"
              [dataTestID]="'profile-item'"
              ><i class="feather icon-user" title="Profile"></i> Profile</a
            >
          </li>
          <li>
            <a
              href="javascript://"
              class="dropdown-item"
              (click)="navigateToSubscription()"
              title="Subscriptions"
              [dataTestID]="'subscription-item'"
              ><i class="fa fa-dollar-sign"></i> Subscription(s)</a
            >
          </li>
        </ul>
        <div class="pro-body mt-0 border-top py-2">
          <li>
            <a
              href="javascript://"
              class="dropdown-item"
              (click)="logout()"
              title="Logout"
              [dataTestID]="'logout-item'"
              ><i class="feather icon-log-out"></i> Logout</a
            >
          </li>
        </div>
      </div>
    </div>
  </li>
</ul>

<section
  class="header-user-list"
  *ngIf="visibleUserList && !this.gradientConfig['rtl-layout']"
  [ngClass]="{ open: visibleUserList }"
  [@slideInOutLeft]
>
  <app-chat-user-list
    (onChatToggle)="onChatToggle($event)"
    (onChatCollapse)="
      this.visibleUserList = !this.visibleUserList; this.chatMessage = false
    "
  ></app-chat-user-list>
</section>

<section
  class="header-chat"
  *ngIf="chatMessage && !this.gradientConfig['rtl-layout']"
  [ngClass]="{ open: chatMessage }"
  [@slideInOutLeft]
>
  <app-chat-msg
    (onChatToggle)="this.chatMessage = !this.chatMessage"
    [friendId]="friendId"
  ></app-chat-msg>
</section>

<section
  class="header-user-list"
  *ngIf="visibleUserList && this.gradientConfig['rtl-layout']"
  [ngClass]="{ open: visibleUserList }"
  [@slideInOutRight]
>
  <app-chat-user-list
    (onChatToggle)="onChatToggle($event)"
    (onChatCollapse)="
      this.visibleUserList = !this.visibleUserList; this.chatMessage = false
    "
  ></app-chat-user-list>
</section>

<section
  class="header-chat"
  *ngIf="chatMessage && this.gradientConfig['rtl-layout']"
  [ngClass]="{ open: chatMessage }"
  [@slideInOutRight]
>
  <app-chat-msg
    (onChatToggle)="this.chatMessage = !this.chatMessage"
    [friendId]="friendId"
  ></app-chat-msg>
</section>

<app-ui-modal
  #modal
  [hideFooter]="true"
  dialogClass="w-100 custom-dialog modal-dialog-centered"
>
  <div class="app-modal-header" style="width: 100%">
    <span
      style="
        color: var(--color-text-primary);
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        float: right;
      "
      (click)="modal.hide()"
      >X</span
    >
  </div>
  <div
    class="app-modal-body"
    style="
      position: relative;
      box-sizing: content-box;
      max-height: 80vh;
      max-height: 80svh;
      width: 100%;
      aspect-ratio: 1.421875;
    "
  >
    <iframe
      [src]="tourGuideUrl"
      title="User onboarding"
      allow="clipboard-write"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      allowfullscreen
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
    ></iframe>
  </div>
</app-ui-modal>
